import React from 'react'
import { Trans } from '@lingui/react/macro'
import { useLingui } from '@lingui/react/macro'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocScreenshot } from '../shared/DocScreenshot'

const Messages = () => {
  const { t } = useLingui()

  return (
    <>
      <Card gap='$4'>
        <Paragraph size='$5'>
          <Trans>
            Event Messages let organizers communicate directly with all
            attendees of an Event. This is the primary way to share updates,
            reminders, and follow-ups with people who have RSVPed or purchased
            tickets.
          </Trans>
        </Paragraph>
        <DocScreenshot
          src='docs/guilds/guild-settings-message.png'
          alt={t`Message compose screen with subject and body fields — Event Messages use the same compose interface`}
          caption={t`Event Messages use the same compose interface as Guild Messages`}
        />
      </Card>

      <Card gap='$4'>
        <DocSection id='message-types' title={t`Message Types`}>
          <YStack gap='$3'>
            <XStack gap='$3' alignItems='flex-start'>
              <Icon
                name='mail'
                size='$5'
                color='$color'
                flexShrink={0}
                marginTop={2}
              />
              <Paragraph size='$5'>
                <Trans>
                  <Paragraph size='$5' fontWeight='$7'>
                    Sending a message
                  </Paragraph>{' '}
                  — Open{' '}
                  <Link href='/docs/events/settings'>Event Settings</Link> and
                  go to the Messages section. Compose your message and click
                  Send. A confirmation dialog will appear before the message is
                  delivered, giving you a chance to review before it goes out to
                  all attendees via email.
                </Trans>
              </Paragraph>
            </XStack>
            <XStack gap='$3' alignItems='flex-start'>
              <Icon
                name='calendar'
                size='$5'
                color='$color'
                flexShrink={0}
                marginTop={2}
              />
              <Paragraph size='$5'>
                <Trans>
                  <Paragraph size='$5' fontWeight='$7'>
                    Pre-Event announcements
                  </Paragraph>{' '}
                  — Send reminders as the Event approaches. Share last-minute
                  details like parking instructions, what to bring, updated
                  schedules, or venue changes. This is especially helpful for
                  in-person Events where attendees need logistics information.
                </Trans>
              </Paragraph>
            </XStack>
            <XStack gap='$3' alignItems='flex-start'>
              <Icon
                name='star'
                size='$5'
                color='$color'
                flexShrink={0}
                marginTop={2}
              />
              <Paragraph size='$5'>
                <Trans>
                  <Paragraph size='$5' fontWeight='$7'>
                    Post-Event follow-ups
                  </Paragraph>{' '}
                  — After the Event, send a thank-you message, share
                  Presentation recordings or slides, link to photo galleries, or
                  announce your next upcoming Event. Follow-up messages help
                  keep your community engaged between gatherings.
                </Trans>
              </Paragraph>
            </XStack>
          </YStack>
        </DocSection>
      </Card>

      <Card gap='$4'>
        <DocSection id='message-delivery' title={t`Message Delivery`}>
          <Paragraph size='$5'>
            <Trans>
              Messages are sent to all current attendees at the time the message
              is created. If someone RSVPs after a message has been sent, they
              will not receive previous messages. Organizers can send multiple
              messages throughout the lifecycle of an Event.
            </Trans>
          </Paragraph>
        </DocSection>
      </Card>
    </>
  )
}

export default Messages
